import { ChevronDown } from "lucide-react";
import { useDeferredValue, useId, useMemo, useState } from "react";

export function SearchableMultiSelect({ label, options, selected, onChange }: { label: string; options: string[]; selected: string[]; onChange: (values: string[]) => void }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const menuId = useId();
  const deferredSearch = useDeferredValue(search);
  const visibleOptions = useMemo(() => {
    const term = deferredSearch.trim().toLowerCase();
    return (term ? options.filter((option) => option.toLowerCase().includes(term)) : options).slice(0, 100);
  }, [options, deferredSearch]);
  const toggle = (option: string) => onChange(selected.includes(option) ? selected.filter((value) => value !== option) : [...selected, option]);

  return <div className={`multi-select-filter${open ? " open" : ""}${selected.length ? " active" : ""}`}>
    <button type="button" className="multi-select-trigger" aria-expanded={open} aria-controls={menuId} onClick={() => setOpen((value) => !value)}>
      <span>{label}{selected.length ? ` (${selected.length})` : ""}</span><ChevronDown />
    </button>
    {open ? <div className="multi-select-menu" id={menuId}>
      <input aria-label={`Search ${label}`} value={search} onChange={(event) => setSearch(event.target.value)} placeholder={`Search ${label.toLowerCase()}…`} />
      <div className="multi-select-options" role="group" aria-label={`${label} options`}>
        {visibleOptions.map((option) => <label key={option}><input type="checkbox" checked={selected.includes(option)} onChange={() => toggle(option)} />{option}</label>)}
        {!visibleOptions.length ? <p>No matches</p> : null}
      </div>
      {options.length > visibleOptions.length ? <small>Showing the first 100 matching options</small> : null}
    </div> : null}
  </div>;
}
